import { render, staticRenderFns } from "./CourrierMail.vue?vue&type=template&id=ccc583ba&scoped=true"
import script from "./CourrierMail.vue?vue&type=script&lang=js"
export * from "./CourrierMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc583ba",
  null
  
)

export default component.exports